exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon__2sH_ {\n  font-size: 15px;\n  margin-left: 5px; }\n", "", {"version":3,"sources":["/app/src/components/button/components/src/components/button/components/LoaderButton.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB,EAClB","file":"LoaderButton.scss","sourcesContent":[".icon {\n  font-size: 15px;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "icon__2sH_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/button/components/LoaderButton.scss
// module id = 759
// module chunks = 0